import {Assets} from './assets.ts';

export class RetirementStrategy {
  static deserialize(data: any): RetirementStrategy {
    const j = (typeof(data) === 'string' ? JSON.parse(data) : data) as Record<string, string | number>;

    return new RetirementStrategy(
      Assets.deserialize(j.preRetirementSavingsRatesPa as string),
      j.postRetirementISASavingRatePa as number,
      j.desired_net_retirement_income as number,
      j.early_pension_withdrawal_pa as number,
      j.max_age_years as number,
    );
  }

  _preRetirementSavingsRatesPa: Assets;
  _postRetirementISASavingRatePa: number;
  _desired_net_retirement_income: number;
  _early_pension_withdrawal_pa: number;
  _max_age_years: number;  // how far should we simulate before it's silly?

  constructor(
    preRetirementSavingsRatesPa: Assets,
    postRetirementISASavingRatePa: number,
    desired_net_retirement_income: number,
    early_pension_withdrawal_pa: number,
    max_age_years: number,
  ) {
    this._preRetirementSavingsRatesPa = preRetirementSavingsRatesPa;
    this._postRetirementISASavingRatePa = postRetirementISASavingRatePa;
    this._desired_net_retirement_income = desired_net_retirement_income;
    this._early_pension_withdrawal_pa = early_pension_withdrawal_pa;
    this._max_age_years = max_age_years;
  }

  serialize(): object {
    return {
      preRetirementSavingsRatesPa: this.preRetirementSavingsRatesPa.serialize(),
      postRetirementISASavingRatePa: this.postRetirementISASavingRatePa,
      desired_net_retirement_income: this.desired_net_retirement_income,
      early_pension_withdrawal_pa: this.early_pension_withdrawal_pa,
      max_age_years: this.max_age_years,
    };
  }

  clone(): RetirementStrategy {
    return new RetirementStrategy(
      this._preRetirementSavingsRatesPa,
      this._postRetirementISASavingRatePa,
      this._desired_net_retirement_income,
      this._early_pension_withdrawal_pa,
      this._max_age_years,
    );
  }

  get preRetirementSavingsRatesPa(): Assets {
    return this._preRetirementSavingsRatesPa;
  }

  get postRetirementISASavingRatePa(): number {
    return this._postRetirementISASavingRatePa;
  }

  set postRetirementISASavingRatePa(val: number) {
    this._postRetirementISASavingRatePa = val;
  }

  get desired_net_retirement_income(): number {
    return this._desired_net_retirement_income;
  }

  set desired_net_retirement_income(val: number) {
    this._desired_net_retirement_income = val;
  }

  get early_pension_withdrawal_pa(): number {
    return this._early_pension_withdrawal_pa;
  }

  set early_pension_withdrawal_pa(val: number) {
    this._early_pension_withdrawal_pa = val;
  }

  get max_age_years(): number {
    return this._max_age_years;
  }
}
